import React from "react";

import {
  MobileMenuContainer,
  ContentContainer,
  MenuBtn,
  MobileNavList,
  NavLink,
  SocialContainer,
} from "./Navigation.style";

import logoMobileSrc from "../../images/logo-mobile.png";

import useLockBodyScroll from "../../hooks/useLockBodyScroll";
import CountdownHeader from "../CountdownHeader/CountdownHeader";
import Social from "../Social/Social";

const MobileMenu = ({ activeSection, onCloseMenu, onGetNotified }) => {
  useLockBodyScroll();

  return (
    <MobileMenuContainer>
      <CountdownHeader />
      <a href="https://olesmoky.com/">
        <img
          src={logoMobileSrc}
          alt="Ole Smoky - Big Green Egg"
          style={{ position: "absolute", top: 60, left: 25, width: 192 }}
        />
      </a>
      <MenuBtn className={"--close"} onClick={onCloseMenu} />

      <ContentContainer>
        <MobileNavList>
          <li>
            <NavLink
              to="/#home"
              className={activeSection === "home" && "--active"}
              onClick={onCloseMenu}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              href="/#prizes"
              className={activeSection === "prizes" && "--active"}
              onClick={onCloseMenu}
            >
              Prizes
            </NavLink>
          </li>
          <li>
            <NavLink
              href="/#cocktails"
              className={activeSection === "cocktails" && "--active"}
              onClick={onCloseMenu}
            >
              Cocktails
            </NavLink>
          </li>
          <li>
            <NavLink
              href="/#bbq"
              className={activeSection === "bbq" && "--active"}
              onClick={onCloseMenu}
            >
              BBQ
            </NavLink>
          </li>
          {/* <li>
            <NavLink
              href="/#faq"
              className={activeSection === "faq" && "--active"}
              onClick={onCloseMenu}
            >
              Faq
            </NavLink>
          </li> */}
          {/* <li>
            <NavLink
              as="button"
              className="--accent"
              onClick={() => {
                onCloseMenu();
                onGetNotified();
              }}
            >
              Enter To Win
            </NavLink>
          </li> */}
        </MobileNavList>

        <SocialContainer>
          <Social />
        </SocialContainer>
      </ContentContainer>
    </MobileMenuContainer>
  );
};

export default MobileMenu;
